<template>
  <a-modal
    title="编辑"
    :maskClosable="false"
    placement="right"
    :visible="userEditVisiable"
    :closable="false"
    @close="onClose"
    style="height: calc(100% - 55px);overflow: auto;padding-bottom: 53px;">
    <a-form :form="form">
      <a-row :gutter="24">
        <a-col :span="12" >
          <a-form-item label='名字'
                       v-bind="formItemLayout">
            <a-input v-decorator="['name',{rules: [{ required: true, message: '名字不能为空'}]}]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12" >
          <a-form-item label="手机号" v-bind="formItemLayout">
            <a-input v-decorator="['phone', {rules: [{ required: true, message: '手机号'}
          ]}]"/>
          </a-form-item>
        </a-col>
      </a-row>


      <a-form-item label="所在区域" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 17 }}">
        <AreaCascader ref="select" />
      </a-form-item>

      <a-row :gutter="24">
        <a-col :span="12" >
          <a-form-item label="门牌号" v-bind="formItemLayout">
            <a-input v-decorator="['doorNo',{rules: []}]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12" >
          <a-form-item label="编号" v-bind="formItemLayout">
            <a-input v-decorator="['no',{rules: []}]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="12" >
          <a-form-item label='性别' v-bind="formItemLayout">
            <a-radio-group v-decorator="['sex',{rules: [{ required: true, message: '请选择性别' }]}]">
              <a-radio :value="0">男</a-radio>
              <a-radio :value="1">女</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12" >
          <a-form-item label="密码" v-bind="formItemLayout">
            <a-input v-decorator="['pwd',{rules: []}]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">


        <a-col :span="12">
          <a-form-item label="是否常驻" v-bind="formItemLayout">
            <a-radio-group v-decorator="['isCz',{rules: [],initialValue:0}]">
              <a-radio :value="0">否</a-radio>
              <a-radio :value="1">是</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>



    </a-form>

    <template slot="footer">
      <a-button key="back" @click="onClose">取消</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
        提交
      </a-button>
    </template>

  </a-modal>
</template>
<script>
  import area from "../../utils/area"
  import store from '../../store'
  import AreaCascader from '@/components/select/AreaCascader'

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 }
  }

  const formItemLayout1 = {
    labelCol: { span: 10 },
    wrapperCol: { span: 13 }
  }
  export default {
    name: 'CheckerEdit',
    components: { AreaCascader},
    props: {
      userEditVisiable: {
        default: false
      }
    },
    data () {
      return {
        options: area,
        user: {
          username: ''
        },
        loading: false,
        id:null,
        streetId:'',
        areas:[],
        roleData: [],
        deptTreeData: [],
        formItemLayout,
        formItemLayout1,
        defaultPassword: '000000',
        form: this.$form.createForm(this),
        validateStatus: '',
        help: '',
        bukId: ''
      }
    },
    mounted(){
      let user = store.state.account.user;
      if(user!=null){
        this.areas = [user.province+"",user.city+"",user.area+""]
        this.streetId = user.streetId
      }
    },
    methods: {
      setFormValues(record){
        this.id = record.id
        this.bukId = record.bukId;
        this.$refs.select.setValue(record.streetId)
        this.form.setFieldsValue({czs:record.czs,identity:record.identity,home:record.home,doorNo:record.doorNo,phone:record.phone,name:record.name,sex:record.sex,streetId:record.streetId,no:record.no,isCz:record.isCz,familyRules:record.familyRules,type:record.type,wg:record.wg,no1:record.no1,no2:record.no2})
      },
      reset () {
        this.validateStatus = ''
        this.help = ''
        this.user.username = ''
        this.loading = false
        this.form.resetFields()
      },
      onClose () {
        this.reset()
        this.$emit('close')
      },
      handleSubmit () {
        this.form.validateFields((err, values) => {
          if (!err ) {
            let datas = this.form.getFieldsValue()
            console.log(datas);
            datas.streetId = this.$refs.select.getValue()
            datas.id = this.id;
            datas.bukId = this.bukId;
            this.loading = true
            this.$post('member/update', datas).then((r) => {
              this.reset()
              this.$emit('success')
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    },
    watch: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/zhuluzhen/MemberEdit.vue